export default {
  setPrint(state, data) {
    state.print = data;
  },

  setReportInfo(state, data) {
    state.reportInfo = data;
  },

  setReportInfoLog(state, data) {
    state.reportInfoLog = data;
  },

  setReportInfoDropDown(state, data) {
    state.reportInfoDropDown = data;
  },
};
